import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var sortIcon = /*#__PURE__*/React.createElement("svg", {
  height: "15",
  width: "13",
  viewBox: "0 0 13 15",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.1",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.506 8.094 2.192 9.92l1.966-1.826",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.332 3.32v6.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.376 4.906 9.69 3.08 7.724 4.906",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.55 9.68v-6.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "2.389",
  cy: "2",
  r: "1.65"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9.493",
  cy: "11",
  r: "1.65",
  transform: "rotate(-180 9.493 11)"
})));

export { sortIcon as default };
//# sourceMappingURL=sortIcon.js.map
